export function AnimatedSplashOverlay() {
  return null;
}
